<script lang="ts">
  import { page } from '$app/stores'
  import Login from '$lib/components/Login.svelte'
  import { PARTNER_STUDIO_ID } from '$lib/constants/partnerStudio'
  import type { ActionData, PageData } from './$types'
  import { LOGIN_STRINGS } from './strings'

  export let data: PageData
  export let form: ActionData

  $: ({ lang, currentCity } = data)
  $: trial = $page.url.searchParams.has('trial')
  $: tier = $page.url.searchParams.has('tier')
  $: credits = $page.url.searchParams.has('credits')
  $: cityId = currentCity?.id ?? 1
</script>

<div class="container">
  {#if trial || tier || credits}
    <div>{LOGIN_STRINGS[lang].STEP}</div>
  {/if}
  <h2>{LOGIN_STRINGS[lang].TITLE}</h2>
</div>
<Login
  {cityId}
  {form}
  hideSocial={$page.url.searchParams.has(PARTNER_STUDIO_ID)}
  hideSignup={$page.url.searchParams.has(PARTNER_STUDIO_ID)}
/>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: start;
    margin: 1em 0;

    h2 {
      text-align: left;
      margin: 0;
    }
  }
</style>
